import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-rent-date-modal',
  templateUrl: './rent-date-modal.component.html',
  styleUrls: ['./rent-date-modal.component.scss'],
})
export class RentDateModalComponent implements OnInit {
  @Input() value: Date;
  constructor(private modelController: ModalController) {}

  filter(event) {
    this.modelController.dismiss(event.detail.value);
  }
  ionViewDidEnter() {
    // this.value = this.value ? this.value : new Date();
  }
  ngOnInit() {}
}
